import { render } from "./ToRawMarkRaw.vue?vue&type=template&id=36ba5325"
import script from "./ToRawMarkRaw.vue?vue&type=script&lang=ts"
export * from "./ToRawMarkRaw.vue?vue&type=script&lang=ts"
script.render = render

export default script